import React from "react";
// eslint-disable-next-line
export default () => {
    return <i className="gg-spinner"></i>;
};
